import { makeStyles } from '@material-ui/core'
import React from 'react'
import PropTypes from 'prop-types'
import {ClipLoader} from 'react-spinners'
import {Space} from 'antd'

const useStyles = makeStyles(theme => ({
    root: {
        background: props => props.disabled ? '#f0f2f5' :  '#1D1D1D',
        padding: props => props.size === "medium" ? theme.spacing(0.8, 1.5) : theme.spacing(0.5, 1),
        borderRadius: 3,
        outline: 'none',
        border: 0,
        color: props => props.disabled ? '#1D1D1D':'#FFFFFF',
        minWidth: props => props.size === "medium" ? 72 : 10,
        display: 'flex',
        alignItems: 'center',
        boxShadow: '0px 1px 4px rgba(21, 34, 50, 0.08)',
    }
}))

/**
 * Primary CTA buttons in the dashboard pages
 */
const CTAButton = ({children, onClick, type="button", loading=false, size='medium', disabled=false}) => {
    const classes = useStyles({size, disabled})

    return (
        <button className={classes.root} onClick={onClick} type={type} disabled={disabled}>
            <Space>
                <ClipLoader color="#FFF" size={20} loading={loading} />
                {children}
            </Space>
            
        </button>
    )
}

CTAButton.propTypes = {
    /** Button content */
    children: PropTypes.element,
    /** Button click handler */
    onClick: PropTypes.func,
    /** Button type, reset, submit or buttin */
    type: PropTypes.oneOf(['button', 'reset', 'submit']),
    /** Is button loading */
    loading: PropTypes.bool,
    /** Determines button width and padding */
    size: PropTypes.oneOf(['small', 'normal']),
    /** Disable the button  */
    disabled: PropTypes.bool
}

export default CTAButton